import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { BrushRounded } from '@mui/icons-material';

type ActionResponse = { hasBranding?: boolean; source?: string } | string | null;
type ActionArgs = { privateProfileId?: string; branding?: Record<string, unknown> };

export type AndieUpdateProfileBrandingProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieUpdateProfileBranding = (props: AndieUpdateProfileBrandingProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.update-profile-branding.title')}
            icon={<BrushRounded fontSize="small" />}
            privateProfileId={props.args?.privateProfileId}
            loadingMessages={() => [t('andie.tool.update-profile-branding.loading')]}
            completeMessage={() => t('andie.tool.update-profile-branding.complete')}
            {...props}
        />
    );
};

export default AndieUpdateProfileBranding;
